/**
 * Single source of truth for product accent colours.
 *
 * These were previously duplicated between Ecosystem.jsx and policyContent.jsx,
 * which is how StrataPulse ended up with three different blues in the codebase.
 * Import from here; do not re-declare a hex anywhere else.
 *
 * Mirrored in design_guidelines.json → colors.product.
 */
export const PRODUCT_COLORS = {
  daubaria: "#DC2626",
  vidaria: "#10B981",
  peraria: "#D4AF37",
  scorepulse: "#00E5FF",
  pixelpulse: "#B6B3B4",
  // Sampled from the supplied app icon rather than estimated, so the card's
  // hover accent matches the cyan in the mark.
  sievepulse: "#08B7F0",
  stratapulse: "#1668DC",
  // Sampled from the official Agos mark. Third product in the green-cyan band
  // alongside Vidaria and SievePulse; it separates in practice because the
  // Agos tile reads as navy with a teal figure, not as a teal field.
  agos: "#57C4B8",
  pocketPeachy: "#D81B60",
  // Evi's light cyan, not its primary. The primary #00C2E8 sits 15.8 RGB from
  // SievePulse; its blue and amber collide with StrataPulse and Peraria. This
  // is the only colour in Evi's own palette that clears every existing accent.
  evi: "#7EDBFF",
};

// Product colour stays confined to the logo tile. Where a product needs to be
// signalled in body content — the "Precise location" badge in the privacy
// policy — the signal is the word, set in neutral text. A tinted badge is
// off-system, and a lightened blue only cleared 4.5:1 on some surfaces anyway.
